import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import Styles from './vm-button.scss';

export default class VmButton extends LitElement {
    static styles = Styles;

    static properties = {
        variant: { type: String },
        size: { type: String },
        custom: { type: String },
        disabled: { type: Boolean, reflect: true },
        active: { type: Boolean },
        type: { type: String },
        minWidth: { type: Boolean, attribute: 'min-width' },
        ariaLabel: { type: String, attribute: 'aria-label' },
    };

    constructor() {
        super();
        this.type = 'button';
        this.disabled = false;
        this.active = false;
        this.minWidth = false;
    }

    get buttonClasses() {
        const classes = {
            'vm-button': true,
            [`vm-button--${this.variant}`]: !!this.variant,
            [`vm-button--${this.size}`]: !!this.size,
            'vm-button--active': this.active,
            'vm-button--min-width': this.minWidth,
        };

        // Support space-separated custom classes (e.g., "comment-cta thumb-up")
        if (this.custom) {
            this.custom.split(/\s+/).forEach((customClass) => {
                if (customClass) {
                    classes[`vm-button--${customClass}`] = true;
                }
            });
        }

        return classes;
    }

    render() {
        // Ensure type is one of the allowed values
        const allowedTypes = ['button', 'submit', 'reset', 'menu'];
        const buttonType = allowedTypes.includes(this.type) ? this.type : 'button';

        return html`
            <button
                class=${classMap(this.buttonClasses)}
                type=${/** @type {'button' | 'submit' | 'reset' | 'menu'} */ (buttonType)}
                ?disabled=${this.disabled}
                aria-label=${this.ariaLabel || ''}
                part="button"
            >
                <slot></slot>
            </button>
        `;
    }
}
